import { jsx as _jsx } from "react/jsx-runtime";
import { CheckboxFactory } from './CheckboxFactory';
import { RadioTick } from './RadioTick';
export function Radio(props) {
    return (_jsx(CheckboxFactory, { isDisabled: props.isDisabled, isHovered: props.isHovered, label: props.children, testId: props.testId, children: _jsx(RadioTick, { name: props.name, value: props.value, isDefaultChecked: props.isDefaultChecked, isChecked: props.isChecked, isDisabled: props.isDisabled, isInvalid: props.isInvalid, isHovered: props.isHovered, onChange: props.onChange, testId: props.testId }) }));
}
//# sourceMappingURL=Radio.js.map